import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { SessionService } from '../../session.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css'],
  standalone: false,
})
export class SignInComponent implements OnInit {

  admin_id?: string;
  password?: string;
  current_language?: string = 'ja';

  editForm: FormGroup;
  adminIdControl!: FormControl;
  passwordControl!: FormControl;
  currentLanguageControl!: FormControl;

  currentLang: string = 'ja';

  constructor(
    private formBuilder: FormBuilder,
    private sessionService: SessionService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
    this.editForm = this.formBuilder.group({
      admin_id: [this.admin_id, [Validators.required, Validators.email]],
      password: [this.password, [Validators.required]],
      current_language: [this.current_language, [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.adminIdControl = this.editForm.get('admin_id') as FormControl;
    this.passwordControl = this.editForm.get('password') as FormControl;
    this.currentLanguageControl = this.editForm.get('current_language') as FormControl;
    this.currentLang = this.translate.currentLang;
  }

  loginMail(): void {
    this.sessionService.setCurrentLanguage(this.currentLanguageControl.value);
    this.sessionService.loginEmail(this.adminIdControl.value, this.passwordControl.value);

  }

  loginGoogle(): void {
    this.sessionService.setCurrentLanguage(this.currentLanguageControl.value);
    this.sessionService.loginGoogle();
  }

  //以下、フォームの記入エラー表示
  public getErrorMessageToAdminId() {
    return this.adminIdControl.hasError('required')
      ? this.translate.instant('必須項目')
    : this.adminIdControl.hasError('email')
          ? this.translate.instant('メール形式')
          : '';
  }
  public getErrorMessageToPassword() {
    return this.passwordControl.hasError('required')
      ? this.translate.instant('必須項目')
    : '';
  }

  switchLanguage(language: string) {
    this.translate.use(language);
    this.current_language = language;
  }
}
